import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar_old";
import Home from "./components/Home/Home";
import RegisterToPicnic from "./components/Picnics/RegisterToPicnic";
import Contacts from "./components/Contacts/Contacts";
import AboutUs from "./components/AboutUs/AboutUs";
import Admin from "./components/Admin/Admin";
import Header from "./components/Header/Header"
import Events from "./components/Events/Events";
import Info from "./components/Info";
import Members from "./components/Members/Members";
import RegisterMember from "./components/RegistrationForms/RegisterMember";
// import StickyLoginButton from "./components/Admin/StickyLoginButton";
import Checklist from "./components/Picnics/Checklist";
import RegisterToEnter from "./components/IndoorGames/RegisterToEnter";
import IndoorGamesTeams from "./components/IndoorGames/RegisterdTeams";
import RegisterToGame from "./components/IndoorGames/RegisterToGame";
import RegisterToNetwork from "./components/RegistrationForms/RegisterToNetwork";
import EventDetails from "./components/Events/EventDetails";
import Gallery from "./components/Gallery/Gallery";
import GalleryAlbum from "./components/Gallery/GalleryAlbum";
import CheckGuest from "./components/NetworkingBuilding/CheckGuest";
import CheckIn from "./components/NetworkingBuilding/CheckIn";
import GuestList from "./components/NetworkingBuilding/GuestList";
import Footer from "./components/Footer/Footer";

//*********** Test ***********//
import Picnic4 from "./components/Picnics/RegisterToPicnic_v4";
import Picnic5 from "./components/Picnics/RegisterToPicnic_v5";
import Test from "./components/Test/Test";

import "./App.css";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />

        <main className="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="aboutus" element={<AboutUs />} />
            <Route path="admin" element={<Admin />} />
            <Route path="events" element={<Events />} />
            <Route
              path="/events/:eventId"
              element={<EventDetails />}
            />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/:eventId" element={<GalleryAlbum />} />

            <Route path="info" element={<Info />} />

            <Route path="checklist" element={<Checklist />} />

            <Route path="members" element={<Members />} />
            <Route path="registermember" element={<RegisterMember />} />

            <Route
              path="registertopicnic"
              element={<RegisterToPicnic />}
            />

            <Route
              path="/registertonetwork"
              element={<RegisterToNetwork />}
            />

            <Route path="checkguest" element={<CheckGuest />} />
            <Route path="checkin" element={<CheckIn />} />
            <Route path="guestlist" element={<GuestList />} />

            <Route
              path="entryform1213"
              element={<RegisterToEnter />}
            />

            <Route
              path="indoorteams"
              element={<IndoorGamesTeams />}
            />

            <Route
              path="registertogame"
              element={<RegisterToGame />}
            />

            <Route path="picnictest" element={<Picnic4 />} />
            <Route path="picnic5" element={<Picnic5 />} />
            <Route path="test" element={<Test />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App;
